import React from "react";
import usePublicInspection from "../../../../tanstack/inspections/public/usePublicInspection";
import CompletedInspectionSummary from "./CompletedInspectionSummary";
import usePublicReInspectionPreviousInspections from "../../../../tanstack/inspections/public/usePublicReInspectionPreviousInspections";
import { InspectionSummaryCommentProps } from "./InspectionSummaryComment";

export interface PublicInspectionSummaryProps {
  id: string | number;
}
export default function PublicInspectionSummary({ id }: PublicInspectionSummaryProps) {
  const { data: inspectionData, isLoading: inspectionLoading } = usePublicInspection({ id });
  const { data: previousInspectionsData, isLoading: previousInspectionsLoading } =
    usePublicReInspectionPreviousInspections({ id });

  const status = inspectionData?.data.attributes.status ?? "";
  const isLoading = inspectionLoading || previousInspectionsLoading;

  const previousComments: InspectionSummaryCommentProps[] =
    previousInspectionsData?.data.map((previousInspection) => {
      const comment = previousInspection.attributes.comment;
      const completedAt = previousInspection.attributes.completedAt;
      const inspectorFirstName = previousInspection.attributes.assignee?.["data"]?.["attributes"]?.["first-name"];
      const inspectorLastName = previousInspection.attributes.assignee?.["data"]?.["attributes"]?.["last-name"];
      return {
        comment: comment ?? "",
        completedAt: completedAt ?? "",
        firstName: inspectorFirstName ?? "",
        lastName: inspectorLastName ?? "",
      };
    }) ?? [];

  const inspectionAttributes = inspectionData?.data.attributes;
  const inspectionComment: InspectionSummaryCommentProps = {
    comment: inspectionAttributes?.comment ?? "",
    completedAt: inspectionAttributes?.completedAt ?? "",
    firstName: inspectionAttributes?.assignee?.["data"]?.["attributes"]?.["first-name"] ?? "",
    lastName: inspectionAttributes?.assignee?.["data"]?.["attributes"]?.["first-name"] ?? "",
  };

  const allComments = [...previousComments, inspectionComment];

  return <CompletedInspectionSummary status={status} comments={allComments} loading={isLoading} />;
}
